<script>
import Drawer from "@/components/drawer";
import Swal from "sweetalert2";

// Custom Components
import PageHeader from "@/components/page-header";
import MiniBarForm from "@/components/miniBarForm.vue";
import hkService from "@/helpers/APIService/hk.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Mini Bar",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Drawer,
    PageHeader,
    MiniBarForm,
  },
  data() {
    return {
      title: "Mini Bar",
      isLoading: true,
      openMiniBarForm: false,
      table: {
        tableData: [],
      },
      selectedItem: null,
      isEdit: false,
      miniItemNameList: [],
    };
  },
  computed: {
    ...authComputed,
    MiniBarFormProps() {
      return {
        selectedItem: this.selectedItem,
        isEdit: this.isEdit,
        miniItemNameList: [...new Set(this.miniItemNameList)],
      };
    },
  },
  mounted() {
    this.getBarItems();
  },
  methods: {
    // Method is use for open and close mini bar form
    miniBarForm() {
      if (this.openMiniBarForm === true) {
        this.isEdit = false;
        this.selectedItem = null;
      }
      this.openMiniBarForm = !this.openMiniBarForm;
    },
    // Method is use for get all mini bar item
    async getBarItems() {
      await hkService
        .getMiniBarItemList()
        .then((item) => {
          item.map((data) => {
            this.miniItemNameList.push(data.name.toLowerCase());
          });
          this.table.tableData = item;
          this.isLoading = false;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use for add and update mini bar item
    MiniBarAddedUpdated(data) {
      if (this.isEdit == true) {
        this.table.tableData = this.table.tableData.map((obj) => {
          if (obj.id == data.id) {
            obj = data;
          }
          return obj;
        });
        Middleware.notification("Successfully updated !!", "success");
      } else {
        this.table.tableData.unshift(data);
        Middleware.notification("Successfully added !!", "success");
      }
      this.miniBarForm();
    },
    // Method is use for update bar item
    editItem(item) {
      this.selectedItem = item;
      this.isEdit = true;
      this.miniBarForm();
    },
    // Method is use for save and add new mini bar item continue
    saveAndAddNewMiniBarItem(data) {
      this.table.tableData.unshift(data);
      Middleware.notification("Successfully added !!", "success");
    },
    // Method is use for delete item form bar
    deleteItem(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          hkService.deleteMiniBarItem(id).then(
            () => {
              let index = this.table.tableData.findIndex((el) => el.id === id);
              this.table.tableData.splice(index, 1);
              Middleware.notification("Successfully deleted !!", "danger");

              this.isLoading = false;
            },
            (error) => {
              errorHandler(error);
            }
          );
        }
      });
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :action="miniBarForm"
      text="Add New Item"
      :isButton="true"
    />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 mt-2">
                <!-- Table -->
                <div class="table-responsive mb-0">
                  <table
                    class="table table-hover mb-0"
                    ref="my-table"
                    v-infinite-scroll="getBarItems"
                    infinite-scroll-disabled="busy"
                    infinite-scroll-distance="10"
                  >
                    <thead class="table-light">
                      <tr>
                        <th>Name</th>
                        <th>Price</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody v-if="isLoading">
                      <tr v-for="(item, index) in 10" :key="index">
                        <td class="placeholder-glow" v-for="no in 3" :key="no">
                          <span class="placeholder w-100 placeholder-lg"></span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr v-for="(data, index) in table.tableData" :key="index">
                        <td @click="editItem(data)">{{ data.name }}</td>
                        <td @click="editItem(data)">{{ data.price }}</td>
                        <td>
                          <div slot="actions" class="d-flex align-items-center">
                            <i
                              class="fas fa-pencil-alt text-success me-1"
                              v-b-popover.hover="'Edit item'"
                              @click="editItem(data)"
                            ></i>
                            <i
                              class="mdi mdi-trash-can ms-2 fs-5 text-danger"
                              v-b-popover.hover="'Delete item'"
                              @click="deleteItem(data.id)"
                            ></i>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-if="!isLoading && table.tableData.length == 0">
                      <tr>
                        <td colspan="9" class="text-center">
                          <img
                            src="@/assets/images/empty.svg"
                            class="img-fluid"
                            alt=""
                          />
                          <p>
                            <span class="text-secondary">No Data Found</span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Drawer
      @close="miniBarForm()"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="openMiniBarForm">
        <MiniBarForm
          :currentProps="MiniBarFormProps"
          @submitted="MiniBarAddedUpdated"
          @cancelSubmit="miniBarForm"
          @saveAndAddNew="saveAndAddNewMiniBarItem"
        />
      </div>
    </Drawer>
  </div>
</template>
